import { useContext } from "react";
import { useQuery } from "react-query";
import { Row } from "react-bootstrap";

import { NoticesService, TypographyService } from "../../Services";
import { UserContext } from "../../Contexts";
import HomeCMSNoticeSkeleton from "./HomeCMSNoticeSkeleton";

import "./HomeCMSNotice.css";

/**
 * HomeCMSNotice component
 *
 * This component fetches and displays CMS notices related to the user's current step.
 * It uses `react-query` to fetch the data from the `NoticesService`, performs validation
 * on image URLs, and displays the resulting content inside a styled notice area.
 *
 * If the data is loading, a skeleton placeholder (`HomeCMSNoticeSkeleton`) is shown.
 *
 * Styling:
 * - Styles are imported from `./HomeCMSNotice.css`.
 *
 * @component
 * @returns {JSX.Element} The rendered CMS notice section
 */
const HomeCMSNotice = () => {
    const { user } = useContext(UserContext);

    const { data: cmsNoticeData, isCMSNoticeDataLoading } = useQuery("CMSNoticeData", async () => {
        const data = (await NoticesService.fetchStatus(user.currentStep)).data;
        const urlPattern = /^(https):\/\/[^ "]+$/;

        return data.map((item) => {
            const imageURL = item.image;

            let image = null;
            if (!!imageURL && urlPattern.test(imageURL) && TypographyService.countChars(imageURL, "/") >= 3) {
                image = imageURL;
            }

            return {
                'content': item.content,
                'image': image,
            }
        });
    });

    if (isCMSNoticeDataLoading || !cmsNoticeData) {
        return (
            <Row className="px-4">
                <HomeCMSNoticeSkeleton />
            </Row>
        );
    }

    return (
        <div className="home-cms-content">
            <h3 className="home-cms-content__heading">Pamiętaj!</h3>
            <div className="home-cms-content__text">
                {cmsNoticeData && cmsNoticeData.map((item) => {
                    return (
                        <p>
                            {item.content}
                        </p>
                    );
                })}
            </div>
        </div>
    );
};

export default HomeCMSNotice;
